import React from 'react'
import { Platform } from 'react-native'

import GoogleSVG from 'app/assets/icons/auth-google.svg'
import Button from 'app/components/base/Button'
import { IS_ANDROID } from 'app/utils/constants/env.constants'

interface GoogleRenderButtonProps {
  onClick: () => void
  disabled?: boolean
  loading?: boolean
}

const GoogleRenderButton: RFC<GoogleRenderButtonProps> = ({
  onClick,
  disabled,
  loading
}) => {
  return (
    <Button
      sx={{
        flex: 1
      }}
      {...Platform.select({
        android: {
          icon: () => <GoogleSVG />
        }
      })}
      onClick={onClick}
      disabled={disabled}
      fullWidth
      variant="outlined"
      loading={loading}
      {...Platform.select({
        native: {
          labelSx: {
            height: 18
          }
        }
      })}
    >
      {!IS_ANDROID && <GoogleSVG />}
    </Button>
  )
}

export default GoogleRenderButton
